import React from 'react';

import { CheckIcon, CrossIcon } from '@vlabs/icons';
import { Divider, Control } from '@vlabs/uikit';

import st from '../CheckboxCustomFilter.module.sass';

export const AddOptionPanel = ({
  value,
  error,
  onChange,
  onCreate,
  onCancel,
}) => {
  return (
    <>
      <div className={st.PanelInLine_full}>
        <div>
          <Control.Input
            data-testid="newOption"
            errorMessage={error || undefined}
            onChange={onChange}
            value={value}
          />
        </div>

        <Control.IconButton
          data-testid="submitAddingNewOption"
          disabled={!!error}
          icon={<CheckIcon />}
          kind="positive"
          onClick={onCreate}
          shape="round"
          size="small"
          variant="outlined"
        />

        <Control.IconButton
          data-testid="cancelAddingNewOption"
          icon={<CrossIcon />}
          kind="secondary"
          onClick={onCancel}
          shape="round"
          size="small"
          variant="outlined"
        />
      </div>
      <Divider small />
    </>
  );
};
